import { Injectable } from '@angular/core';
// import { RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/defer';
import { ApiService } from '../api.service';
import { Elasticpatterncollection, PatternNew, PatternPatch } from 'ri-api-client/dist';
import { ApiQueryParams } from './api-query-params';
import { forkJoin } from '../../../../node_modules/rxjs/observable/forkJoin';

export interface Pattern {
    risk: string;
    idPattern: number;
    pattern: {
        name: string, app: { name: string }
    };
    isPatternInUse: boolean
}

@Injectable()
export class PatternService {
    private options: any;

    constructor(
        private apiService: ApiService
    ) {
        // const headers = new Headers({ 'Content-Type': 'application/json' });
        // this.options = new RequestOptions({ headers: headers });
        // this.apiService.init();
    }

    getByfilter(query: ApiQueryParams): Observable<any[]> {
        return this.apiService.client.patterns.GET(query.fields, query.filter, query.group, query.aggregatedFields, query.sort, query.page, query.archivedOnly, query.opts)
        .map((res) => {
            return this.apiService.handleResponse(res);
        });
    }

    getAll(query: ApiQueryParams): Observable<any[]> {
        return this.apiService.client.patterns.GET(query.fields, query.filter, query.group, query.aggregatedFields, query.sort, query.page, query.archivedOnly, query.opts)
        .map(
            (res) => {
                return this.apiService.handleResponse(res);
            }
        )
    }

    getCount(filter: string): Observable<any> {
        return this.getByfilter({
            filter: filter,
            aggregatedFields: 'Count()'
        })
    }

    getPatternWithCount(query: ApiQueryParams): Observable<any> {
        const dataQuery = this.getByfilter(query);
        const countQuery = this.getCount(query.filter);
        return forkJoin([dataQuery, countQuery]);
    }

    getUCsQtyByRiskRange(ucFilter: string, filter: string): Observable<any[]> {
        return this.apiService.client.patterns.results.riskrange.GET(ucFilter, filter)
            .map((res) => {
                return this.apiService.handleResponse(res);
            });
    }

    createNewPattern(pattern: PatternNew.PatternNew): Observable<any> {
        return this.apiService.client.patterns.POST(pattern, this.options);
    }

    editPattern(id: number, pattern: PatternPatch.PatternPatch): Observable<any> {
        return this.apiService.client.patterns.id(String(id)).PATCH(pattern, this.options);
    }

    getUCsQtyMultiplePatterns(ucFilter: string, filter: string): Observable<number> {
        return this.apiService.client.patterns.results.multiplesources.GET(ucFilter, filter)
            .map((res) => {
                return this.apiService.handleResponse(res);
            });
    }

    submitResultsFile(extraFields: string, id: number, fileContents: string, cleanPreviousResult?: boolean, stopOnMissingUcs?: boolean, atomicTransactions?: boolean) {
        return this.submitResultsFileContents(extraFields, id, fileContents, cleanPreviousResult, stopOnMissingUcs, atomicTransactions);
    }
    submitResultsFileContents(extraFields: string, id: number, fileContents: string, cleanPreviousResult?: boolean, stopOnMissingUcs?: boolean, atomicTransaction?: boolean) {
        return this.apiService.client.patterns.id(String(id)).update.POST(extraFields, fileContents, cleanPreviousResult, stopOnMissingUcs, atomicTransaction, this.options);
    }

    getSubmittedProgress(id: number, idProgress: string) {
        return this.apiService.client.patterns.id(String(id)).update.progressId(idProgress).GET(this.options);
    }

    getArchived(query: ApiQueryParams): Observable<any> {
        return this.apiService.client.patterns.GET(query.fields, query.filter, query.group, query.aggregatedFields, query.sort, query.page, true, query.opts).map((res) => res.bodyRaw.results );
    }

    getArchivedCount(filter: string): Observable<any> {
        return this.getArchived({
            filter: filter,
            aggregatedFields: 'Count()'
        })
    }

    getArchivedWithCount(query: ApiQueryParams): Observable<any> {
        const dataQuery = this.getArchived(query);
        const countQuery = this.getArchivedCount(query.filter);
        return forkJoin([dataQuery, countQuery]);
    }

    deletePattern(id: number) {
        return this.apiService.client.patterns.id(String(id)).DELETE(this.options);
    }

    restorePattern(id: number, pattern: PatternPatch.PatternPatch) {
        return this.apiService.client.patterns.id(String(id)).activate.PATCH(pattern, this.options);
    }

    submitResultsFromFileHandle(extraFields: string, id: number, file: File, cleanPreviousResult?: boolean, stopOnMissingUcs?: boolean, atomicTransaction?: boolean): Observable<any> {
        const reader = new FileReader();
        return Observable.defer<any>(() => Observable.create(x => {
            reader.onloadend = () => {
                this.submitResultsFileContents(extraFields, id, reader.result as string, cleanPreviousResult, stopOnMissingUcs, atomicTransaction)
                    .subscribe((response) => {
                        x.next(this.apiService.handleResponse(response));
                        x.complete();
                    }, (error) => x.error(error));
            };
            reader.onerror = () => {
                x.error(reader.error);
            };
            reader.readAsText(file);
        }));
    }

    getElasticPatttern(filter: string, sort: string): Observable<any> {
        return this.apiService.client.patterns.getPatternsData.GET(filter, sort)
        .map(res => res.bodyRaw);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/api/pattern.service.ts